<div class="container-fluid bg-transparent py-3">
  <button (click)="toggleSidebar()" class="btn btn-blue">
    <span class="text-400 text-14 text-nunito text-FFFFFF">MENÚ</span>
    <img src="assets/icons/hamburguesa.svg" alt="" class="ms-3"/>
  </button>
</div>